// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--space-0: 0;
	--space-1: 2px;
	--space-2: 4px;
	--space-3: 6px;
	--space-4: 8px;
	--space-5: 10px;
	--space-6: 12px;
	--space-7: 14px;
	--space-8: 16px;
	--space-9: 18px;
	--space-10: 20px;
	
}

@media(max-width: 1300px) {
	:root {
		--space-0: 0;
		--space-1: 1px;
		--space-2: 2px;
		--space-3: 4px;
		--space-4: 6px;
		--space-5: 8px;
		--space-6: 10px;
		--space-7: 12px;
		--space-8: 14px;
		--space-9: 16px;
		--space-10: 18px;
	}
}

@media(max-width: 1100px) {
	:root {
		--space-0: 0;
		--space-1: .5px;
		--space-2: 1px;
		--space-3: 2px;
		--space-4: 4px;
		--space-5: 6px;
		--space-6: 8px;
		--space-7: 10px;
		--space-8: 12px;
		--space-9: 14px;
		--space-10: 16px;
	}
}

@media(min-width: 1500px) {
	:root {
		--space-0: 0;
		--space-1: 4px;
		--space-2: 6px;
		--space-3: 8px;
		--space-4: 10px;
		--space-5: 12px;
		--space-6: 14px;
		--space-7: 16px;
		--space-8: 18px;
		--space-9: 20px;
		--space-10: 22px;
	}
}

@media(min-width: 2000px) {
	:root {
		
		--space-0: 0;
		--space-1: 6px;
		--space-2: 8px;
		--space-3: 10px;
		--space-4: 12px;
		--space-5: 14px;
		--space-6: 16px;
		--space-7: 18px;
		--space-8: 20px;
		--space-9: 22px;
		--space-10: 24px;
	}
}`, "",{"version":3,"sources":["webpack://./src/Theme/Space/space.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,cAAc;CACd,cAAc;CACd,cAAc;CACd,cAAc;CACd,eAAe;CACf,eAAe;CACf,eAAe;CACf,eAAe;CACf,eAAe;CACf,gBAAgB;;AAEjB;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;CACjB;AACD;;AAEA;CACC;;EAEC,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;CACjB;AACD","sourcesContent":[":root {\r\n\t--space-0: 0;\r\n\t--space-1: 2px;\r\n\t--space-2: 4px;\r\n\t--space-3: 6px;\r\n\t--space-4: 8px;\r\n\t--space-5: 10px;\r\n\t--space-6: 12px;\r\n\t--space-7: 14px;\r\n\t--space-8: 16px;\r\n\t--space-9: 18px;\r\n\t--space-10: 20px;\r\n\t\r\n}\r\n\r\n@media(max-width: 1300px) {\r\n\t:root {\r\n\t\t--space-0: 0;\r\n\t\t--space-1: 1px;\r\n\t\t--space-2: 2px;\r\n\t\t--space-3: 4px;\r\n\t\t--space-4: 6px;\r\n\t\t--space-5: 8px;\r\n\t\t--space-6: 10px;\r\n\t\t--space-7: 12px;\r\n\t\t--space-8: 14px;\r\n\t\t--space-9: 16px;\r\n\t\t--space-10: 18px;\r\n\t}\r\n}\r\n\r\n@media(max-width: 1100px) {\r\n\t:root {\r\n\t\t--space-0: 0;\r\n\t\t--space-1: .5px;\r\n\t\t--space-2: 1px;\r\n\t\t--space-3: 2px;\r\n\t\t--space-4: 4px;\r\n\t\t--space-5: 6px;\r\n\t\t--space-6: 8px;\r\n\t\t--space-7: 10px;\r\n\t\t--space-8: 12px;\r\n\t\t--space-9: 14px;\r\n\t\t--space-10: 16px;\r\n\t}\r\n}\r\n\r\n@media(min-width: 1500px) {\r\n\t:root {\r\n\t\t--space-0: 0;\r\n\t\t--space-1: 4px;\r\n\t\t--space-2: 6px;\r\n\t\t--space-3: 8px;\r\n\t\t--space-4: 10px;\r\n\t\t--space-5: 12px;\r\n\t\t--space-6: 14px;\r\n\t\t--space-7: 16px;\r\n\t\t--space-8: 18px;\r\n\t\t--space-9: 20px;\r\n\t\t--space-10: 22px;\r\n\t}\r\n}\r\n\r\n@media(min-width: 2000px) {\r\n\t:root {\r\n\t\t\r\n\t\t--space-0: 0;\r\n\t\t--space-1: 6px;\r\n\t\t--space-2: 8px;\r\n\t\t--space-3: 10px;\r\n\t\t--space-4: 12px;\r\n\t\t--space-5: 14px;\r\n\t\t--space-6: 16px;\r\n\t\t--space-7: 18px;\r\n\t\t--space-8: 20px;\r\n\t\t--space-9: 22px;\r\n\t\t--space-10: 24px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
